
export default {
  data() {//Declaracao de variaveis
    return {
      validacao: {
        cpfCnpj: [
          v => !!v || this.$t("messages.validacao.cpfCnpjVazio"),
          v => (v && this.validaCpfCnpj(v)) || this.msg,
        ],

        cpf: [
          v => !!v || this.$t("messages.validacao.cpfVazio"),
          v => (v && this.validaCpf(v)) || this.$t("messages.validacao.cpfInValido")
        ],

        cnpj: [
          v => !!v || this.$t("messages.validacao.cnpjVazio"),
          v => (v && this.validaCnpj(v)) || this.$t("messages.validacao.cnpjInValido")
        ],

        email: [
          v => !!v || this.$t("messages.validacao.emailVazio"),
          v => (v && this.validaEmail(v)) || this.$t("messages.validacao.emailInValido")
        ],

        emailValid: [
          v => (this.validaEmail(v)) || this.$t("messages.validacao.emailInValido")
        ],

        campoObrigatorio: [v => !!v || this.$t("messages.validacao.campoObrigatorio")],

        validAlphaNumeric: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validAlphaNumeric(v) || this.$t("messages.validacao.alphaNumeric")],

        validAlphaNumericCaracter: [
            v => !!v || this.$t("messages.validacao.campoObrigatorio"),
            v => this.validAlphaNumericCaracter(v) || this.$t("messages.validacao.alphaNumericCaracter")],

        campoTelefone: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 14) || this.$t("messages.validacao.telefoneInValido")
        ],

        campoCelular: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 15) || this.$t("messages.validacao.celularInValido")
        ],
        campoCelularEst: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 13) || this.$t("messages.validacao.celularInValido")
        ],
        campoFax: [
          v => this.validQtd(v, 14) || this.$t("messages.validacao.faxInValido")
        ],

        campoTelefoneAdicional: [
          v => this.validQtd(v, 14) || this.$t("messages.validacao.telefoneAdicionalInvalido")
        ],

        campoCep: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 10) || this.$t("messages.validacao.cepInValido")
        ],

        campoRG: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio")         
        ],

        finalidadeEmpresa: [
          // finalidade empresa => "Sem fins lucrativos" === 0, "Com fins lucrativos" === 1
          v => (v != null) || this.$t("messages.validacao.campoObrigatorio"),
        ],

        codigoCredor: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => v.length === 10 || this.$t("messages.validacao.codigoCredorInvalido")
        ]
      },
      msg: this.$t("messages.validacao.cpfCnpjVazio"),
    }
  },
  methods: {//Declaracao de todos os metodos

    validaCpfCnpj(cpfCnpj) {

      cpfCnpj = cpfCnpj.replace(/[^\d]+/g, '');


      if (cpfCnpj.length < 11) {
        this.msg = this.$t("messages.validacao.cpfCnpjInValido")
        return false;
      } else {

        if (cpfCnpj.length === 11) {
          this.msg = this.$t("messages.validacao.cpfInValido");
          return this.validaCpf(cpfCnpj)

        } else {
          this.msg =  this.$t("messages.validacao.cnpjInValido")
          return this.validaCnpj(cpfCnpj)

        }

      }

    },

    validaCpf(cpf) {
      var regexCpf = /^(([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2})|([0-9]{11}))$/;
      if(regexCpf.test(cpf))
        return this.testCPF(cpf);
      else
        return false;
    },

    validaCnpj(cnpj) {
      var regexCnpj = /^((\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})|([0-9]{14}))$/;
      if(regexCnpj.test(cnpj))
        return this.testCNPJ(cnpj);
      else
        return false;
    },

    validaEmail(email) {
      if (email == null || email === "" )
        return true

      var regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regexEmail.test(email);
    },
    validAlphaNumeric: function(value){
      var re = /(?=.*[a-zA-Z])[a-zA-Z0-9]{6,8}/g; 

      if (!!value && (value.length < 6 || value.length > 8))
        return false;     

			return re.test(value);
		},    
    validAlphaNumericCaracter: function(value){
      var ca = /^(?=.*[0-9])(?=.*[a-zA-Z!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?~])[^']{6,8}$/;
  
      if (!!value && (value.length < 6 || value.length > 8))
          return false;
  
      return ca.test(value);
  },
    validQtd: function(value, qtd){
      return !(!!value && value.length < qtd);
		},
    testCPF: function(cpf){
      var Soma = 0;
      var Resto = 0;
      var i = 0;

      // Garante que o valor é uma string
      cpf = cpf.toString();

      // Remove caracteres inválidos do valor
      cpf = cpf.replace(/[^\d]+/g, '');

      if (cpf === "00000000000" || cpf === "11111111111"
      || cpf === "22222222222" || cpf === "33333333333"
      || cpf === "44444444444" || cpf === "55555555555"
      || cpf === "66666666666" || cpf === "77777777777"
      || cpf === "88888888888" || cpf === "99999999999") return false;

      for (i=1; i<=9; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto !== parseInt(cpf.substring(9, 10)) ) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto !== parseInt(cpf.substring(10, 11) ) ) return false;
      return true;
    },
    testCNPJ: function(cnpj)
    {
      // Garante que o valor é uma string
      cnpj = cnpj.toString();

      // Remove caracteres inválidos do valor
      cnpj = cnpj.replace(/[^\d]+/g, '');

      if (cnpj === "00000000000000" || cnpj === "11111111111111"
      || cnpj === "22222222222222" || cnpj === "33333333333333"
      || cnpj === "44444444444444" || cnpj === "55555555555555"
      || cnpj === "66666666666666" || cnpj === "77777777777777"
      || cnpj === "88888888888888" || cnpj === "99999999999999") return false;

      var tamanho = cnpj.length - 2;
      var numeros = cnpj.substring(0,tamanho);
      var digitos = cnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;
      var i = 0;

      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos;
        pos--;
        if (pos < 2) pos = 9;
      }

      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;

      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos;
        pos--;
        if (pos < 2) pos = 9;
      }

      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) return false;

      return true;
    }
  }
};
